import Cancellation from './Cancellation.vue';

export default Cancellation;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/purchases/components/cancellation/index.ts